import {ILocationCreateRequest, LocationCreateRequest, ILocationAggregate} from "./models";

export interface ILocationUpdateRequest extends ILocationCreateRequest {
    locationId: string;
    addressId: string;
}

export class LocationUpdateRequest extends LocationCreateRequest implements ILocationUpdateRequest {
    public locationId: string;
    public addressId: string;
}